// This file was generated using `pay js:run gql-v1 --type=mutation --name=EmbeddedAuthenticationLink --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1MutationOptionsWithoutVariables,
  V1MutationOptions,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Mutation} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, ApolloError} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1EmbeddedAuthenticationLinksInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation EmbeddedAuthenticationLinkMutation(
    $input: OpenapiPostV1EmbeddedAuthenticationLinksInput
    $v1Context: V1ContextInput!
  ) {
    v1EmbeddedAuthenticationLinks(input: $input, v1Context: $v1Context) {
      id
      url
    }
  }
`;

export const embeddedAuthenticationLinkMutation: EmbeddedAuthenticationLinkMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const embeddedAuthenticationLinkMutationOptions: V1MutationOptionsWithoutVariables<EmbeddedAuthenticationLinkMutationDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...

    // TODO: This is a legacy behavior that was present in the original Apollo
    // wrappers and is not standard. If you are not using this error for anything
    // feel free to remove it (More info: go/throw-errors-on-mutations)
    onError(error: ApolloError) {
      throw error;
    },
  };

export default function useEmbeddedAuthenticationLinkMutation(
  options: V1MutationOptions<EmbeddedAuthenticationLinkMutationDocument> = {},
): V1MutationReturn<EmbeddedAuthenticationLinkMutationDocument> {
  return useV1Mutation(
    embeddedAuthenticationLinkMutation,
    Object.assign({}, embeddedAuthenticationLinkMutationOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type EmbeddedAuthenticationLinkMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1EmbeddedAuthenticationLinksInput>;
  v1Context: V1ContextInput;
}>;

export type EmbeddedAuthenticationLinkMutationData = {
  readonly __typename: 'Mutation';
  readonly v1EmbeddedAuthenticationLinks: {
    readonly __typename: 'OpenapiConnectEmbeddedMethodEmbeddedAuthenticationLinkCreateMethodEmbeddedAuthenticationLink';
    readonly id: string;
    readonly url: string;
  } | null;
};

const embeddedAuthenticationLinkMutationPermissions = {} as const;

doc.permissions = embeddedAuthenticationLinkMutationPermissions;

export type EmbeddedAuthenticationLinkMutationPermissions = V1PermissionToken<
  typeof embeddedAuthenticationLinkMutationPermissions
>;

export type EmbeddedAuthenticationLinkMutationDocument = GraphQlDocument<
  EmbeddedAuthenticationLinkMutationData,
  EmbeddedAuthenticationLinkMutationVariables,
  EmbeddedAuthenticationLinkMutationPermissions
>;
